<app-top-navbar [title]="'profile-form.consent' | translate"/>

<div class="wrapper page-consent">
  <app-loyalty-club-header [customHTML]="false"/>

  <div class="content">
    <app-consent-form/>
  </div>

  <app-loyalty-club-footer/>
</div>

